import { useAppSelector } from '@/redux/hooks';
import { selectCanWriteContentAssemblyTasks } from '@/redux/selectors/authSelectors';
import { SegmentItem } from '@/redux/slices/packagingSlice.types';

interface Props {
  segments: SegmentItem[];
  isLoadingStatusFulfilled: boolean;
  isSubmitting: boolean;
}

export const useTemplateTimelineValidation = ({ segments = [], isLoadingStatusFulfilled, isSubmitting }: Props) => {
  const canWriteContentAssemblyTasks = useAppSelector(selectCanWriteContentAssemblyTasks);
  const isTimelineEmpty = segments.length === 0;
  const isAssemblyTemplateUpdateButtonDisabled = !canWriteContentAssemblyTasks || !isLoadingStatusFulfilled || isSubmitting || isTimelineEmpty;

  const dontHaveWritePermissionMessage = "You don't have permission to change templates";

  const updateTemplateButtonTooltip = !canWriteContentAssemblyTasks
    ? dontHaveWritePermissionMessage
    : isTimelineEmpty
      ? 'Add at least one segment to the timeline'
      : undefined;

  return {
    isAssemblyTemplateUpdateButtonDisabled,
    updateTemplateButtonTooltip
  };
};
